import { render } from "./administratorAccount.vue?vue&type=template&id=69aa02db&scoped=true"
import script from "./administratorAccount.vue?vue&type=script&lang=js"
export * from "./administratorAccount.vue?vue&type=script&lang=js"

import "./administratorAccount.vue?vue&type=style&index=0&id=69aa02db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69aa02db"

export default script